export default __webpack_public_path__ + "static/media/corcega-gr20-calenzana-conca.746c310a.gpx";